import { z } from 'zod';

import { aiStatusSchema } from '../ai';
import { brandCreateSchema, brandSchema } from '../brand';
import { urlSchema, urlSchemaOptional } from '../shared';

// List
export const listReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type ListReq = z.infer<typeof listReqSchema>;

export const listResSchema = {
  200: z.object({
    data: z.array(brandSchema),
  }),
};
export type ListRes = z.infer<(typeof listResSchema)[200]>;

// GetById
export const getByIdReqSchema = z.object({
  params: z.object({
    id: brandSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type GetByIdReq = z.infer<typeof getByIdReqSchema>;

export const getByIdResSchema = {
  200: z.object({
    data: brandSchema,
  }),
};
export type GetByIdRes = z.infer<(typeof getByIdResSchema)[200]>;

// Create
export const createBrandReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z
    .object({
      isOnboarding: z
        .string()
        .transform(function (val) {
          if (typeof val !== 'string') {
            return val;
          }

          return val.toLowerCase() === 'true' || val === '1';
        })
        .or(z.boolean())
        .nullish(),
    })
    .nullish(),
  body: brandCreateSchema.strip(),
});
export type CreateBrandReq = z.infer<typeof createBrandReqSchema>;

export const createBrandResSchema = {
  200: z.object({
    data: brandSchema,
  }),
};
export type CreateBrandRes = z.infer<(typeof createBrandResSchema)[200]>;

// Save
export const saveBrandReqSchema = z.object({
  params: z.object({
    id: brandSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: brandCreateSchema.partial().strip(),
});
export type SaveBrandReq = z.infer<typeof saveBrandReqSchema>;

export const saveBrandResSchema = {
  200: z.object({
    data: brandSchema,
  }),
};
export type SaveBrandRes = z.infer<(typeof saveBrandResSchema)[200]>;

// Delete
export const deleteBrandReqSchema = z.object({
  params: z.object({
    id: brandSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type DeleteBrandReq = z.infer<typeof deleteBrandReqSchema>;

export const deleteBrandResSchema = {
  200: z.object({}),
};
export type DeleteBrandRes = z.infer<(typeof deleteBrandResSchema)[200]>;

//////////////////////////
// Generate brand context
export const generateBrandContextReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z.object({}).nullish(),
  body: z
    .object({
      contentId: z.string(),
      country: z.string().nullish(),
      language: z.string().nullish(),
      homepage: urlSchema,
      blogPostList: z.array(urlSchemaOptional as z.ZodSchema<string>).nullish(),
      productPageList: z.array(urlSchemaOptional as z.ZodSchema<string>).nullish(),
    })
    .strip(),
});
export type GenerateBrandContextReq = z.infer<typeof generateBrandContextReqSchema>;

export const generateBrandContextResSchema = {
  200: z.object({
    ok: z.boolean(),
    jobId: z.string().nullish(),
  }),
};
export type GenerateBrandContextRes = z.infer<(typeof generateBrandContextResSchema)[200]>;

export const generateBrandContextSocketResSchema = z.object({
  contentId: z.string(),
  result: brandSchema.partial().nullish(),
  status: aiStatusSchema,
  error: z.string(),
});
export type GenerateBrandContextSocketResSchema = z.infer<
  typeof generateBrandContextSocketResSchema
>;

// Job Status
export const jobStatusReqSchema = z.object({
  params: z.object({
    id: brandSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type JobStatusReq = z.infer<typeof jobStatusReqSchema>;

export const jobStatusResSchema = {
  200: z.object({
    status: aiStatusSchema,
    progress: z.number().nullish(),
    error: z.string().nullish(),
    jobId: z.string().nullish(),
  }),
};
export type JobStatusRes = z.infer<(typeof jobStatusResSchema)[200]>;

// JOB DATA REQUEST
export const jobDataReqSchema = z.object({
  params: z.object({
    jobId: z.string(),
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type JobDataReq = z.infer<typeof jobDataReqSchema>;

export const jobDataResSchema = {
  200: z.object({
    result: brandSchema.partial().nullish(),
    error: z.string().nullish(),
    status: aiStatusSchema,
  }),
};
export type JobDataRes = z.infer<(typeof jobDataResSchema)[200]>;
